function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_730",
  "data-name": "Grupo 730",
  transform: "translate(131.415 -180.785)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_5345",
  "data-name": "Caminho 5345",
  d: "M-114.179,188.632a5.814,5.814,0,0,0-5.807,5.807,5.814,5.814,0,0,0,5.807,5.808,5.815,5.815,0,0,0,5.808-5.808,5.814,5.814,0,0,0-5.808-5.807Zm0,8.747a2.942,2.942,0,0,1-2.939-2.94,2.942,2.942,0,0,1,2.939-2.939,2.942,2.942,0,0,1,2.94,2.939,2.942,2.942,0,0,1-2.94,2.94Zm0,0",
  transform: "translate(-1.822 -1.251)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_5346",
  "data-name": "Caminho 5346",
  d: "M-110.716,207.238c.421-.448.852-.924,1.284-1.423,3.872-4.469,5.835-8.484,5.835-11.934v-.692a12.418,12.418,0,0,0-12.4-12.4,12.419,12.419,0,0,0-12.4,12.4v.692c0,3.45,1.964,7.466,5.836,11.934.432.5.863.975,1.284,1.423-4.011.438-10.131,1.653-10.131,4.988,0,1.78,1.733,3.157,5.15,4.093A40.551,40.551,0,0,0-116,217.493a40.546,40.546,0,0,0,10.265-1.174c3.417-.936,5.15-2.313,5.15-4.093,0-3.333-6.1-4.549-10.13-4.988Zm-14.819-13.357v-.692A9.546,9.546,0,0,1-116,183.653a9.547,9.547,0,0,1,9.536,9.536v.692c0,2.694-1.766,6.161-5.107,10.024A49.6,49.6,0,0,1-116,208.382a49.625,49.625,0,0,1-4.4-4.444c-3.359-3.877-5.135-7.355-5.135-10.056Zm18.421,19.833a39.6,39.6,0,0,1-8.885.912,39.607,39.607,0,0,1-8.885-.912c-2.479-.6-3.328-1.232-3.584-1.487a6.518,6.518,0,0,1,2.735-1.263A33.442,33.442,0,0,1-118.6,209.9c.979.9,1.64,1.445,1.7,1.49l.9.736.905-.736c.055-.045.716-.586,1.7-1.49a33.55,33.55,0,0,1,7.112,1.061,6.552,6.552,0,0,1,2.757,1.269c-.256.255-1.1.89-3.584,1.487Zm0,0",
  fill: "#fff"
}));

var SvgLocation = function SvgLocation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30.829,
    height: 36.708,
    viewBox: "0 0 30.829 36.708",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/location.d230d6e9.svg";
export { ForwardRef as ReactComponent };